import React from 'react';
import { useAuth } from 'hooks/useAuth';
import { Navigation } from 'navigation';
import 'assets/styles/common.scss';
import 'assets/styles/antd_customizations.scss';

export const App = () => {
  useAuth();
  return <Navigation />;
};
